module.exports = __webpack_public_path__ + "images/avatar-s-9.397f0acd.jpg";